export default __webpack_public_path__ + "static/media/Blade's Belt of the Grim Cabal.e9fe1958.jpg";